
import FiltersSidebar from "./FiltersSidebar";
import QuestionsGrid from "./QuestionsGrid";

const ManualSelectionTab = ({
  questionFilters,
  setQuestionFilters,
  questionPage,
  setQuestionPage,
  questionsData,
  questionsLoading,
  categoriesData,
  selectedQuestions,
  handleQuestionToggle,
  getSubCategories,
}) => {
  return (
    <div className="flex h-[600px] border rounded-lg overflow-hidden">
      <FiltersSidebar
        questionFilters={questionFilters}
        setQuestionFilters={setQuestionFilters}
        setQuestionPage={setQuestionPage}
        categoriesData={categoriesData}
      />
      <QuestionsGrid
        questionsData={questionsData}
        questionsLoading={questionsLoading}
        selectedQuestions={selectedQuestions}
        handleQuestionToggle={handleQuestionToggle}
        questionPage={questionPage}
        setQuestionPage={setQuestionPage}
      />
    </div>
  );
};

export default ManualSelectionTab;
